<template>
  <div class="module_course page_content entity_learn_instructor" aria-label="Entity Learn Page Content">
    <course-header :course-id="course.uuid" :entityUuid="entityUuid" class="header_entity"></course-header>
    <div class="row page-content" :class="isTocOpen ? 'toc_activated' : ''">
      <div class="col-12 course-description can_full_screen full_screen">
        <div class="header">
          <div v-if="entity.fileType === 'assessment'" class="icon icon-assessment"></div>
          <div v-if="entity.fileType === 'video'" class="icon icon-iconVideo-0005"></div>
          <div v-if="entity.fileType === 'pdf'" class="icon icon-file-pdf"></div>
          <div v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="icon icon-file-word"></div>
          <div v-if="entity.fileType === 'ppt' || entity.fileType === 'pptx'" class="icon icon-pagePPT"></div>
          <div v-if="entity.fileType === 'xls' || entity.fileType === 'xlsx'" class="icon icon-file-excel"></div>
          <div v-if="entity.fileType === 'html' || entity.fileType === 'externalurl'" class="icon icon-pageURL"></div>
          <div v-if="entity.fileType === 'zip'" class="icon icon-file-zip"></div>
          <div v-if="entity.fileType === 'other'" class="icon icon-asset"></div>
          <div v-if="entity.fileType === 'scorm'" class="icon icon-scorm"></div>
          <div v-if="entity.fileType === 'externalurl'" class="icon icon-pageURL"></div>
          <div v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="icon icon-image"></div>

          <div class="heading" v-b-tooltip.hover.topright :title="entity.title" :aria-label="entity.title">
            {{ancestor}} > {{parent}} > {{entity.title}}
          </div>

          <div class="btn_container">
            <b-button v-if="entity.fileType !== 'assessment'" class="btn button-primary next" :to="{ name: 'entityDetailInstructor', params: { uuid: uuid, entityType: entityType, entityUuid: entityUuid } }"> done </b-button>
            <full-screen-method></full-screen-method>
          </div>
        </div>
        <div class="entity-learn-content">
          <template v-if="isLtiLink">
            <iframe width="100%" height="415" :src="ltiLaunchUrl" frameborder="0"></iframe>
          </template>
          <template v-else>
            <template v-if="entity.type === 'RICH_HTML'">
              <rich-html-launch-assessment :resource-id="entityUuid" :html="entity.htmlBody" :course-id="course.uuid" :container-class="'rich-html-container-learn'" ></rich-html-launch-assessment>
            </template>
            <template v-else>
              <div v-if="entity.fileType === 'pdf' || entity.fileType === 'gif' || entity.fileType === 'png' || entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'doc' || entity.fileType === 'docx' || entity.fileType === 'ppt' || entity.fileType === 'pptx' || entity.fileType === 'html' || entity.fileType === 'other' || entity.fileType === 'externalurl' || entity.fileType === 'mp3'  || entity.fileType === 'mp4' || entity.fileType === 'zip'" class="container pdf-container">
                <p class="pull-right lnk_open_new_tab_container" v-if="showLoadingMessage && entity.fileType !== 'zip'"><a target="_blank" :href="entity.uri" class="lnk_open_new_tab"><span class="icon-new-tab"></span> Open this resource in a new tab</a></p>
                <iframe v-if="showIframe" width="100%" height="415" :src="entity.iframeUrl" frameborder="0"></iframe>
              </div>
              <div v-if="entity.fileType === 'scorm'" class="container pdf-container">
                <iframe width="100%" height="415" :src="scormPreviewUrl" frameborder="0"></iframe>
              </div>
              <div v-if="entity.fileType === 'video'" class="container">
                <p class="pull-right lnk_open_new_tab_container" v-if="showLoadingMessage"><a target="_blank" :href="entity.uri" class="lnk_open_new_tab"><span class="icon-new-tab"></span> Open this resource in a new tab</a></p>
                <template v-if="entity.categoryId === '00011'">
                  <youtube v-if="!showLoadingMessage" :video-id="entity.yt" ref="youtube" style="width: 100%; height: 86%;"></youtube>
                </template>
                <template v-else>
                  <iframe :src="entity.iframeUrl" frameborder="0"></iframe>
                </template>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseHeader from './CourseHeader'
import CourseNav from './CourseNav'
import TOC from './TOC'
import RichHtmlLaunchAssessment from '../../assessment/components/RichHtmlLaunchAssessment'
import fullScreenMethod from '../../common/components/fullScreenMethod'

var specialDocuments = {
  'csv': 'CSV',
  'dif': 'Data Interchange Format',
  'msword': 'Microsoft Word',
  'doc': 'Microsoft Word',
  'docm': 'Macro Enabled Document',
  'docx': 'Microsoft Word',
  'dot': 'Word 97-2003 Template',
  'dotm': 'Macro Enabled Template',
  'dotx': 'Microsoft Word Template',
  'mht': 'Single Web Page',
  'mhtml': 'Single page html',
  'odt': 'Open Document',
  'pdf': 'PDF',
  'pm': 'Formated Text',
  'ppt': 'Power Point',
  'pptx': 'Power Point',
  'prn': 'PRN',
  'rtf': 'Rich Text Format',
  'slk': 'SYLK',
  'thmx': 'THMX',
  'wps': 'Works 6-9 Document',
  'xls': 'Excel',
  'xlsb': 'Excel Workbook',
  'xlsx': 'Excel',
  'xlsm': 'Excel Macro Enabled Workbook',
  'xlt': 'Excel Template',
  'xps': 'XPS',
  'php': 'PHP',
  'c': 'C'
}

var staticWhiteList = function () {
  var whiteList = [
    'https://cnx.org/contents/yqV9q0HH@9.765:EjCWRC94@20/Introduction-to-Integers',
    'https://cnx.org/contents/yqV9q0HH@9.765:6XWvp3tz@15/Rational-and-Irrational-Number#fs-id1767079',
    'https://cnx.org/contents/yqV9q0HH@9.765:mPpwTKiz@16/Decimals',
    'https://cnx.org/contents/yqV9q0HH@9.765:eANu7eiL@19/Add-Integers',
    'https://cnx.org/contents/yqV9q0HH@9.765:tl-gRL_E@22/Subtract-Integers',
    'https://cnx.org/contents/yqV9q0HH@9.765:LUUW7a32@17/Multiply-and-Divide-Integers',
    'https://cnx.org/contents/yqV9q0HH@9.765:LUUW7a32@17/Multiply-and-Divide-Integers#fs-id1718637',
    'https://cnx.org/contents/yqV9q0HH@9.765:PMJZgY6F@13/Add-and-Subtract-Fractions-wit',
    'https://cnx.org/contents/yqV9q0HH@9.765:6jhr4kLA@13/Add-and-Subtract-Fractions-wit',
    'https://cnx.org/contents/yqV9q0HH@9.765:PMJZgY6F@13/Add-and-Subtract-Fractions-wit#fs-id1594413',
    'https://cnx.org/contents/yqV9q0HH@9.765:6jhr4kLA@13/Add-and-Subtract-Fractions-wit#fs-id1276143',
    'https://cnx.org/contents/yqV9q0HH@9.765:s7ku6WX5@18/Multiply-and-Divide-Fractions',
    'https://cnx.org/contents/yqV9q0HH@9.765:0L7hpyVK@15/Decimal-Operations#fs-id1358621',
    'https://cnx.org/contents/yqV9q0HH@9.765:s7ku6WX5@18/Multiply-and-Divide-Fractions#fs-id2700526',
    'https://cnx.org/contents/yqV9q0HH@9.765:0L7hpyVK@15/Decimal-Operations#fs-id2471378',
    'https://cnx.org/contents/yqV9q0HH@9.765:iIOMae_5@20/Understand-Percent',
    'https://cnx.org/contents/yqV9q0HH@9.765:534pfj8-@15/Use-the-Language-of-Algebra#fs-id1395398',
    'https://cnx.org/contents/yqV9q0HH@9.765:534pfj8-@15/Use-the-Language-of-Algebra#fs-id2661619',
    'https://cnx.org/contents/yqV9q0HH@9.765:534pfj8-@15/Use-the-Language-of-Algebra#fs-id2139130',
    'https://cnx.org/contents/yqV9q0HH@9.765:LUUW7a32@17/Multiply-and-Divide-Integers#fs-id1714226',
    'https://cnx.org/contents/yqV9q0HH@9.765:LUUW7a32@17/Multiply-and-Divide-Integers#fs-id1919519',
    'https://cnx.org/contents/yqV9q0HH@9.765:534pfj8-@15/Use-the-Language-of-Algebra#fs-id1193286',
    'https://cnx.org/contents/yqV9q0HH@9.765:nmU2s-CD@13/Commutative-and-Associative-Pr',
    'https://cnx.org/contents/yqV9q0HH@9.765:6kJ5Z57B@13/Distributive-Property',
    'https://cnx.org/contents/yqV9q0HH@9.765:IOqEQ0kt@12/Properties-of-Identity-Inverse',
    'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/Evaluate-Simplify-and-Translat#fs-id1733229',
    'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/Evaluate-Simplify-and-Translat#fs-id1232396',
    'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/Evaluate-Simplify-and-Translat#fs-id2241263',
    'https://cnx.org/contents/yqV9q0HH@9.765:p8Ut5CsA@17/Evaluate-Simplify-and-Translat#fs-id2707610',
    'https://cnx.org/contents/yqV9q0HH@9.765:6XWvp3tz@15/Rational-and-Irrational-Number#fs-id1535083',
    'https://cnx.org/contents/yqV9q0HH@9.765:nmU2s-CD@13/Commutative-and-Associative-Pr#fs-id1166478989599',
    'https://cnx.org/contents/yqV9q0HH@9.765:IOqEQ0kt@12/Properties-of-Identity-Inverse#fs-id1166497460665',
    'https://cnx.org/contents/yqV9q0HH@9.765:IOqEQ0kt@12/Properties-of-Identity-Inverse#fs-id1166497481181',
    'https://cnx.org/contents/yqV9q0HH@9.765:IOqEQ0kt@12/Properties-of-Identity-Inverse#fs-id1166497459880',
    'https://cnx.org/contents/yqV9q0HH@9.765:cY13ivLF@13/Solve-Equations-with-Variables',
    'https://cnx.org/contents/yqV9q0HH@9.765:9eEtMKQa@19/Solving-Equations-Using-the-Su#fs-id2318611',
    'https://cnx.org/contents/yqV9q0HH@9.765:6e_1mRFC@14/Solve-Equations-Using-the-Subt',
    'https://cnx.org/contents/yqV9q0HH@9.765:nzp1RlZu@13/Solve-Equations-Using-the-Divi',
    'https://cnx.org/contents/yqV9q0HH@9.765:534pfj8-@15/Use-the-Language-of-Algebra#fs-id2139102',
    'https://cnx.org/contents/yqV9q0HH@9.765:9eEtMKQa@19/Solving-Equations-Using-the-Su#fs-id1549757',
    'https://cnx.org/contents/yqV9q0HH@9.765:UGK4inAC@17/Use-a-Problem-Solving-Strategy#fs-id1533728',
    'https://cnx.org/contents/yqV9q0HH@9.765:FRtcjj64@21/Solve-Sales-Tax-Commission-and#fs-id1499142',
    'https://cnx.org/contents/yqV9q0HH@9.765:plAnVHMc@20/Solve-Simple-Interest-Applicat',
    'https://cnx.org/contents/yqV9q0HH@9.765:IwAsSXsh@19/Solve-a-Formula-for-a-Specific',
    'https://cnx.org/contents/yqV9q0HH@9.765:jq9gwbWo@12/Add-Whole-Numbers#fs-id2594070',
    'https://cnx.org/contents/yqV9q0HH@9.765:HpMawx93@20/Use-Properties-of-Rectangles-T#fs-id1171505778736',
    'https://cnx.org/contents/yqV9q0HH@9.765:4A4IPh7R@20/Use-Properties-of-Angles-Trian',
    'https://cnx.org/contents/yqV9q0HH@9.765:HpMawx93@20/Use-Properties-of-Rectangles-T#fs-id1797142',
    'https://cnx.org/contents/yqV9q0HH@9.765:Lvahg2k3@20/Use-the-Rectangular-Coordinate',
    'https://cnx.org/contents/yqV9q0HH@9.765:zf9Dhl3V@19/Understand-Slope-of-a-Line',
    'https://cnx.org/contents/yqV9q0HH@9.765:j1MbsS9b@19/Graphing-Linear-Equations#fs-id1515845',
    'https://cnx.org/contents/yqV9q0HH@9.765:j1MbsS9b@19/Graphing-Linear-Equations',
    'https://cnx.org/contents/CImQfPDv@2.44:lBmVYBst@3/Add-and-Subtract-Integers#fs-id1170655124054',
    'https://cnx.org/contents/CImQfPDv@2.44:HRhzJGFq@3/Visualize-Fractions',
    'https://cnx.org/contents/CImQfPDv@2.44:lBmVYBst@3/Add-and-Subtract-Integers#fs-id1170654942142',
    'https://cnx.org/contents/CImQfPDv@2.44:lBmVYBst@3/Add-and-Subtract-Integers#fs-id1170654942216',
    'https://cnx.org/contents/CImQfPDv@2.44:DgkT5Ky_@2/Multiply-and-Divide-Integers#fs-id1170652620585',
    'https://cnx.org/contents/CImQfPDv@2.44:DgkT5Ky_@2/Multiply-and-Divide-Integers#fs-id1170653874776',
    'https://cnx.org/contents/CImQfPDv@2.44:s3Hqb5IM@2/Add-and-Subtract-Fractions',
    'https://cnx.org/contents/CImQfPDv@2.44:HRhzJGFq@3/Visualize-Fractions#fs-id1170653910468',
    'https://cnx.org/contents/CImQfPDv@2.44:HRhzJGFq@3/Visualize-Fractions#fs-id1170654110168',
    'https://cnx.org/contents/CImQfPDv@2.44:NciJ1qa0@3/Decimals#fs-id1170655102379',
    'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654982105',
    'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654942632',
    'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654928809',
    'https://cnx.org/contents/CImQfPDv@2.44:DgkT5Ky_@2/Multiply-and-Divide-Integers#fs-id1170653761875',
    'https://cnx.org/contents/CImQfPDv@2.44:DgkT5Ky_@2/Multiply-and-Divide-Integers#fs-id1170652624016',
    'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654953465',
    'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170655163482',
    'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers',
    'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654889475',
    'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654942537',
    'https://cnx.org/contents/CImQfPDv@2.44:dgB2SHi0@3/The-Real-Numbers#fs-id1170655121069',
    'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers#fs-id1170653871089',
    'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers#fs-id1170653774811',
    'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers#fs-id1170654074010',
    'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers#fs-id1170653800718',
    'https://cnx.org/contents/CImQfPDv@2.44:wpHBgnDi@3/Properties-of-Real-Numbers#fs-id1170654077757',
    'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654957085',
    'https://cnx.org/contents/CImQfPDv@2.44:OWpkn8_G@2/Solve-Equations-Using-the-Subt#fs-id1168345560615',
    'https://cnx.org/contents/CImQfPDv@2.44:OWpkn8_G@2/Solve-Equations-Using-the-Subt',
    'https://cnx.org/contents/CImQfPDv@2.44:9ujtiwpG@2/Solve-Equations-using-the-Divi',
    'https://cnx.org/contents/CImQfPDv@2.44:4GK6JSQo@2/Solve-Linear-Inequalities',
    'https://cnx.org/contents/CImQfPDv@2.44:4GK6JSQo@2/Solve-Linear-Inequalities#fs-id1168341960485',
    'https://cnx.org/contents/CImQfPDv@2.44:4GK6JSQo@2/Solve-Linear-Inequalities#fs-id1168345517735',
    'https://cnx.org/contents/CImQfPDv@2.44:4GK6JSQo@2/Solve-Linear-Inequalities#fs-id1168345667361',
    'https://cnx.org/contents/CImQfPDv@2.44:4GK6JSQo@2/Solve-Linear-Inequalities#fs-id1168345500407',
    'https://cnx.org/contents/CImQfPDv@2.44:faHRo7tY@3/Use-the-Language-of-Algebra#fs-id1170654938230',
    'https://cnx.org/contents/CImQfPDv@2.44:Tj87ETCR@3/Use-a-Problem-Solving-Strategy',
    'https://cnx.org/contents/CImQfPDv@2.44:Tj87ETCR@3/Use-a-Problem-Solving-Strategy#fs-id1168344319176',
    'https://cnx.org/contents/CImQfPDv@2.44:RMC_iBKa@2/Solve-Percent-Applications#fs-id1168345389218',
    'https://cnx.org/contents/CImQfPDv@2.44:Z8sTwcjE@3/Solve-Mixture-Applications#fs-id1168345458172',
    'https://cnx.org/contents/CImQfPDv@2.44:Z8sTwcjE@3/Solve-Mixture-Applications#fs-id1168345415718',
    'https://cnx.org/contents/CImQfPDv@2.44:Dt6yb2pr@3/Solve-Uniform-Motion-Applicati',
    'https://cnx.org/contents/CImQfPDv@2.44:BW6bMUQm@2/Solve-Geometry-Applications-Tr#fs-id1168345561789',
    'https://cnx.org/contents/CImQfPDv@2.44:BW6bMUQm@2/Solve-Geometry-Applications-Tr#fs-id1168345363664',
    'https://cnx.org/contents/CImQfPDv@2.44:THpXLlSz@2/Solve-Applications-with-Linear',
    'https://cnx.org/contents/CImQfPDv@2.44:S6EErGb5@3/Use-the-Rectangular-Coordinate',
    'https://cnx.org/contents/CImQfPDv@2.44:ukK0bN45@2/Understand-Slope-of-a-Line',
    'https://cnx.org/contents/CImQfPDv@2.44:tegV4wXG@4/Use-the-SlopeIntercept-Form-of',
    'https://cnx.org/contents/CImQfPDv@2.44:_LEEVWcM@2/Find-the-Equation-of-a-Line#fs-id1169596704299',
    'https://cnx.org/contents/CImQfPDv@2.44:_LEEVWcM@2/Find-the-Equation-of-a-Line#fs-id1169596497114',
    'https://cnx.org/contents/CImQfPDv@2.44:_LEEVWcM@2/Find-the-Equation-of-a-Line#fs-id1169596441994',
    'https://cnx.org/contents/CImQfPDv@2.44:uoU4SZ4O@2/Graph-Linear-Equations-in-Two-#fs-id1169596298887',
    'https://cnx.org/contents/CImQfPDv@2.44:uoU4SZ4O@2/Graph-Linear-Equations-in-Two-#fs-id1169596497621',
    'https://cnx.org/contents/CImQfPDv@2.44:1fOoAbOR@3/Graphs-of-Linear-Inequalities#fs-id1169596219884',
    'https://cnx.org/contents/CImQfPDv@2.44:1fOoAbOR@3/Graphs-of-Linear-Inequalities#fs-id1169596441313',
    'http://cdn.kutasoftware.com/Worksheets/Alg1/Graphing%20Linear%20Inequalities.pdf',
    'http://www.wallace.ccfaculty.org/book/0.1%20Integers.pdf',
    'http://www.wallace.ccfaculty.org/book/0.2%20Fractions.pdf',
    'http://www.wallace.ccfaculty.org/book/0.4%20Properties%20of%20Algebra.pdf',
    'http://www.wallace.ccfaculty.org/book/0.4%20Properties%20of%20Algebra%20Practice.pdf',
    'http://www.wallace.ccfaculty.org/book/1.1%20One-Step%20Equations.pdf',
    'http://www.wallace.ccfaculty.org/book/2.2%20Slope.pdf',
    'http://www.wallace.ccfaculty.org/book/2.2%20Slope%20Practice.pdf',
    'http://www.wallace.ccfaculty.org/book/2.3%20Slope%20Intercept%20Practice.pdf',
    'http://www.wallace.ccfaculty.org/book/2.4%20Point-Slope%20Practice.pdf',
    'http://www.wallace.ccfaculty.org/book/3.1%20Simple%20Inequalities%20Practice.pdf',
    'http://www.wallace.ccfaculty.org/book/Beginning_and_Intermediate_Algebra.pdf',
    'https://courses.lumenlearning.com/beginalgebra/chapter/rules-for-adding-real-numbers/',
    'https://courses.lumenlearning.com/boundless-algebra/chapter/variables-and-expressions/',
    'https://courses.lumenlearning.com/boundless-algebra/chapter/further-exponents/',
    'https://courses.lumenlearning.com/boundless-algebra/chapter/introduction-to-arithmetic-operations/',
    'https://www.boundless.com/algebra/textbooks/boundless-algebra-textbook/introduction-to-equations-inequalities-and-graphing-2/variables-and-expressions-16/introduction-to-variables-368-17412/',
    'https://www.cliffsnotes.com/study-guides/algebra/algebra-i/preliminaries-and-basic-operations/properties-of-basic-mathematical-operations',
    'https://www.cliffsnotes.com/study-guides/algebra/algebra-i/terminology-sets-and-expressions/variables-and-algebraic-expressions',
    'https://www.cliffsnotes.com/study-guides/basic-math/basic-math-and-pre-algebra/variables-algebraic-expressions-and-simple-equations/variables-and-algebraic-expressions',
    'https://cnx.org/contents/CImQfPDv@2.44:D5n2sgz3@3/Solve-Systems-of-Equations-by-#fs-id1168341923821',
    'https://cnx.org/contents/CImQfPDv@2.44:D5n2sgz3@3/Solve-Systems-of-Equations-by-#fs-id1168345440846',
    'https://cnx.org/contents/CImQfPDv@2.44:D5n2sgz3@3/Solve-Systems-of-Equations-by-#CNX_ElemAlg_Figure_05_01_015',
    'https://cnx.org/contents/CImQfPDv@2.44:jLGlZ6m5@3/Solve-Systems-of-Equations-by-#fs-id1168345216137',
    'https://cnx.org/contents/CImQfPDv@2.44:jLGlZ6m5@3/Solve-Systems-of-Equations-by-#fs-id1168345695456',
    'https://cnx.org/contents/CImQfPDv@2.44:jLGlZ6m5@3/Solve-Systems-of-Equations-by-#fs-id1168345285072',
    'https://cnx.org/contents/CImQfPDv@2.44:V1Ef26Jq@2/Solve-Systems-of-Equations-by-#fs-id1168345742458',
    'https://cnx.org/contents/CImQfPDv@2.44:V1Ef26Jq@2/Solve-Systems-of-Equations-by-#fs-id1168345511491',
    'https://cnx.org/contents/CImQfPDv@2.44:V1Ef26Jq@2/Solve-Systems-of-Equations-by-#fs-id1168345357619',
    'https://cnx.org/contents/CImQfPDv@2.44:ZArS1Z0P@5/Solve-Applications-with-System#fs-id1168344525268',
    'https://cnx.org/contents/CImQfPDv@2.44:ZArS1Z0P@5/Solve-Applications-with-System#fs-id1168343064826',
    'https://cnx.org/contents/CImQfPDv@2.44:SadrhUaw@2/Add-and-Subtract-Polynomials#fs-id1169596392601',
    'https://cnx.org/contents/CImQfPDv@2.44:SadrhUaw@2/Add-and-Subtract-Polynomials#fs-id1169596396806',
    'https://cnx.org/contents/CImQfPDv@2.44:SadrhUaw@2/Add-and-Subtract-Polynomials#fs-id1169596453928',
    'https://cnx.org/contents/CImQfPDv@2.44:SadrhUaw@2/Add-and-Subtract-Polynomials#fs-id1169596365153',
    'https://cnx.org/contents/CImQfPDv@2.44:UeFfacK9@2/Multiply-Polynomials#fs-id1169596397302',
    'https://cnx.org/contents/CImQfPDv@2.44:UeFfacK9@2/Multiply-Polynomials#fs-id1169596410084',
    'https://cnx.org/contents/CImQfPDv@2.44:UeFfacK9@2/Multiply-Polynomials#fs-id1169596303926',
    'https://cnx.org/contents/CImQfPDv@2.44:R3vcJIkA@4/Special-Products',
    'https://cnx.org/contents/CImQfPDv@2.44:i_n2_vn1@2/Integer-Exponents-and-Scientif#fs-id1169597494141',
    'https://cnx.org/contents/CImQfPDv@2.44:i_n2_vn1@2/Integer-Exponents-and-Scientif#fs-id1169597539588',
    'https://cnx.org/contents/CImQfPDv@2.44:i_n2_vn1@2/Integer-Exponents-and-Scientif#fs-id1169597689465',
    'https://cnx.org/contents/CImQfPDv@2.44:SSXOP9oB@4/Divide-Polynomials#fs-id1169597410581',
    'https://cnx.org/contents/CImQfPDv@2.44:SSXOP9oB@4/Divide-Polynomials#fs-id1169597481790',
    'https://cnx.org/contents/CImQfPDv@2.44:Dgyhg24R@3/Greatest-Common-Factor-and-Fac#fs-id1168341853057',
    'https://cnx.org/contents/CImQfPDv@2.44:Dgyhg24R@3/Greatest-Common-Factor-and-Fac#fs-id1168345277984',
    'https://cnx.org/contents/CImQfPDv@2.44:Dgyhg24R@3/Greatest-Common-Factor-and-Fac#fs-id1168345406018',
    'https://cnx.org/contents/CImQfPDv@2.44:KekUrtBj@5/Factor-Quadratic-Trinomials-wi',
    'https://cnx.org/contents/CImQfPDv@2.44:ntLHiuvZ@3/Factor-Quadratic-Trinomials-wi',
    'https://cnx.org/contents/CImQfPDv@2.44:p-75hORO/Factor-Special-Products',
    'https://cnx.org/contents/CImQfPDv@2.44:WId3lCUh@2/Simplify-Rational-Expressions#fs-id1169596555147',
    'https://cnx.org/contents/CImQfPDv@2.44:WId3lCUh@2/Simplify-Rational-Expressions#fs-id1169596765280',
    'https://cnx.org/contents/CImQfPDv@2.44:WId3lCUh@2/Simplify-Rational-Expressions#fs-id1169596234350',
    'https://cnx.org/contents/CImQfPDv@2.44:H1BI5dWO@2/Multiply-and-Divide-Rational-E#fs-id1169597485048',
    'https://cnx.org/contents/CImQfPDv@2.44:H1BI5dWO@2/Multiply-and-Divide-Rational-E#fs-id1169595235043',
    'https://cnx.org/contents/CImQfPDv@2.44:Q1yBn-wZ@2/Add-and-Subtract-Rational-Expr',
    'https://cnx.org/contents/CImQfPDv@2.44:9_tGuTDU@2/Add-and-Subtract-Rational-Expr#fs-id1169597479058',
    'https://cnx.org/contents/CImQfPDv@2.44:9_tGuTDU@2/Add-and-Subtract-Rational-Expr',
    'https://cnx.org/contents/CImQfPDv@2.44:QiOXd9L3@2/Simplify-Complex-Rational-Expr',
    'https://cnx.org/contents/CImQfPDv@2.44:lD27fVyp@2/Solve-Rational-Equations',
    'https://cnx.org/contents/CImQfPDv@2.44:lD27fVyp@2/Solve-Rational-Equations#fs-id1169597705349',
    'https://cnx.org/contents/CImQfPDv@2.44:s2Pana65@2/Solve-Proportion-and-Similar-F',
    'https://cnx.org/contents/CImQfPDv@2.44:DyIv0UeH@2/Simplify-and-Use-Square-Roots',
    'https://cnx.org/contents/CImQfPDv@2.44:wDB3sj46@2/Simplify-Square-Roots',
    'https://cnx.org/contents/CImQfPDv@2.44:DyIv0UeH@2/Simplify-and-Use-Square-Roots#fs-id1169596704683',
    'https://cnx.org/contents/CImQfPDv@2.44:wDB3sj46@2/Simplify-Square-Roots#fs-id1169596453704',
    'https://cnx.org/contents/CImQfPDv@2.44:vfPRgYoW@2/Add-and-Subtract-Square-Roots',
    'https://cnx.org/contents/CImQfPDv@2.44:K59eZ3ai/Multiply-Square-Roots',
    'https://cnx.org/contents/CImQfPDv@2.44:20M2B5Ot@2/Divide-Square-Roots',
    'https://cnx.org/contents/CImQfPDv@2.44:vfPRgYoW@2/Add-and-Subtract-Square-Roots#fs-id1169596685926',
    'https://cnx.org/contents/CImQfPDv@2.44:K59eZ3ai@2/Multiply-Square-Roots#fs-id1169595122726',
    'https://cnx.org/contents/CImQfPDv@2.44:20M2B5Ot@2/Divide-Square-Roots#fs-id1169596348306',
    'https://cnx.org/contents/CImQfPDv@2.44:DHh18HNo@2/Quadratic-Equations#fs-id1168345500421',
    'https://cnx.org/contents/CImQfPDv@2.44:Xk8nuhrb@2/Solve-Quadratic-Equations-Usin',
    'https://cnx.org/contents/CImQfPDv@2.44:bs9oZaKb@2/Solve-Quadratic-Equations-by-C',
    'https://cnx.org/contents/CImQfPDv@2.44:mwyQCpKo@2/Solve-Quadratic-Equations-Usin',
    'https://s3.amazonaws.com/nile-nu-dev-content/024fb4b1-ca40-4e08-8450-44a4a7829566.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/0403becb-788d-409b-b93e-c6807c6411a9.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/0e3e5f54-5364-432e-8549-bb516fd702b2.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/268f27b8-595e-4a06-8530-2291f9418e38.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/29a1850f-cee9-4b62-bf57-d8e2bbb04f0f.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/37392129-5771-4144-a6ce-02983392c2c9.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/3fe33b41-eea9-49c1-9004-214621f16cfb.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/4f89ba44-3802-431e-8062-40487000d30f.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/6986e8c4-3743-4292-b04e-a6725cbdc9f7.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/6ce067ec-dfc2-4bd4-8cb4-645419209054.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/813305c5-0a83-4699-9ab7-3aeb2e7133f9.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/915cccc3-ce32-43cf-9548-a5402a005806.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/9f045751-c0d5-4698-adb9-a7cc79893ef9.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/a730b171-1d6a-44c3-b4a0-a3acd3824306.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/aba61895-519b-4f4d-9caf-ca6cd18e6124.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/bfcf596a-77a3-4405-ab55-67f175424ab3.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/c2193755-bd34-47cd-a209-e823d037267c.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/caedbed3-f4b5-4475-8b2e-9bc7d3b05ce9.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/e767dfc6-c3d2-4a25-ac92-682739901473.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/e7d5f2de-e83d-4db0-b6c3-1cfdf8e9650c.pdf',
    'https://s3.amazonaws.com/nile-nu-dev-content/fdca1243-355d-4059-95fe-b31d31f4f17c.pdf',
    'http://www.wallace.ccfaculty.org/book/4.1%20Graphing%20Systems%20Practice.pdf',
    'http://www.wallace.ccfaculty.org/book/4.2%20Substitution%20Practice.pdf',
    'https://www.algebra.com/algebra/homework/coordinate/Types-of-systems-inconsistent-dependent-independent.lesson',
    'https://www.wyzant.com/resources/lessons/math/algebra/simplifying-negative-exponents',
    'https://www.mathportal.org/algebra/solving-system-of-linear-equations/substitution-method.php',
    'https://www.mathportal.org/algebra/roots-and-radicals/adding-and-subtracting-radicals.php',
    'https://www.mathplanet.com/education/algebra-1/rational-expressions/multiply-rational-expressions',
    'https://www.ck12.org/book/CK-12-Algebra-II-with-Trigonometry-Concepts/section/3.5/',
    'https://themathlab.com/Algebra/polynomials/divpoly.htm',
    'https://www.basic-mathematics.com/elimination-method.html',
    'https://secure-media.collegeboard.org/apc/ap_arthistory_teachers_guide.pdf',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b8850e2e4b07b0e730a71a0-Course%20Opening%20ITL530a.pdf?versionId=WywpSZDGzhjNOqOZfyUD7zfciG0yq9ww',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b8851efe4b07b0e730a71a2-MC1%20Instructions.pdf?versionId=6cRgH_wZygEq5YEd0tRrImfJd97i05EK',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b8865bee4b06ec81d11adb7-Week%20One%20Assignment%20Classroom%20Management%20Video%20Critique.pdf?versionId=4YdY02M75QeHTnsBTLSakjyjneXYiekt',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b87450ee4b07b0e730a6c81-MC%202%20instructions.pdf?versionId=fyW.mGqSCt9uIoxOeDQo08RaOOuVW3gV',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b87452be4b07b0e730a6c82-MC4%20Instructions.pdf?versionId=EN4Kd.tkafvn.n9yrZr5LMdgtkvyAaK5',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b8878f8e4b07b0e730a71fe-Module%20Two%20Content.pdf?versionId=kIl9AX4.zBZTWWi8le0.h7Xa.L0J3bO',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b8878eee4b07b0e730a71fd-MC5%20Instructions.pdf?versionId=fsFPowdQ5trpqz2GWJ2zxTXQ7nijHC7s',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b887910e4b07b0e730a7200-MC6%20Instructions.pdf?versionId=tSFCBD7SG_qD6iS4bsIa6FuYRyFPzaSJ',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b887d8de4b06ec81d11ae05-Module%20Two%20Discussions.pdf?versionId=nNiTgZW24Yxxs3RD82JXhdcO981IaIE5',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b887934e4b06ec81d11adf6-MC8%20Instructions.pdf?versionId=LYz.UEv7LI0ekBNkiSh7aZIxBCJqKu4V',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b88794ee4b07b0e730a7205-MC10%20Instructions.pdf?versionId=uUKReex20DrXJrWtl.n40FRqf3Qp0n45',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89b891e4b07b0e730a7358-Module%20Three%20Content.pdf?versionId=1rt.mDEeYQGd7a0VzXFdA9UoltDA7YDx',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89b89de4b06ec81d11af38-Module%20Three%20Readings.pdf?versionId=BeUZlIfpUOQAh6QhMQbPmgsUn.WFwZ.u',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89b87de4b06ec81d11af37-MC11%20Instructions.pdf?versionId=IjOAa7q2zXz9RfYERT8EbGsjbqU85sBL',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89b9f5e4b07b0e730a7362-MC12%20Instructions.pdf?versionId=B93Um2BIYWwpM_DcesajWeYpjiv0v615',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89ba04e4b07b0e730a7363-MC13%20Instructions.pdf?versionId=eWiRv8teurGlwSdES8Q9LMAnvzCXvpKu',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89ba12e4b06ec81d11af39-MC14%20Instructions.pdf?versionId=evfaKi.bKz5t1Cav3aGiPix5Z84XhKAt',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89bb71e4b06ec81d11af3b-Module%20Four%20Readings.pdf?versionId=.h6liGBPID8yFTVbHP_dkrqt3RSMXhgq',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89bb97e4b06ec81d11af3e-RTI%20Volume4%20Issue2.pdf?versionId=jWDkcWFzN8J1dmh0i1fsmC_.gGLRJMHr',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89bb8fe4b07b0e730a736a-RTI%20essentialcomponents_042710.pdf?versionId=v46rucr3bwis4K0pGtVCb1ctaEtDxdCs',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89bc7ce4b07b0e730a7371-MC16%20Instructions.pdf?versionId=LlsIdLrhX1RX7S8PXSjDBZ5cLPaEsQ0k',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89bc89e4b07b0e730a7372-MC%2017%20Instructions.pdf?versionId=FotLTIWVO90WQIrnglWh3b1MccTOolnk',
    'https://pragya2.s3-us-west-2.amazonaws.com/5b89bc96e4b07b0e730a7373-MC18%20Instructions.pdf?versionId=ccUZmS5ngMt6YdLg1hCbYzqhl3tSPzux'
  ]
  return whiteList
}

export default {
  name: 'entity-learn-instructor',
  props: ['uuid', 'entityType', 'entityUuid'],
  components: {
    CourseHeader,
    CourseNav,
    TOC,
    RichHtmlLaunchAssessment,
    fullScreenMethod
  },
  data: () => {
    return {
      page: 1,
      rating: 0,
      parent: null,
      ancestor: null,
      uri: '',
      isLtiLink: false,
      ltiLaunchUrl: '',
      scormPreviewUrl:"",
      blackList: [
        'https://ca.pbslearningmedia.org/resource/lsps07.sci.phys.matter.covalentbond/covalent-bonding/#.WO64mNLytPY',
        'https://ca.pbslearningmedia.org/resource/7eb9615f-f534-4772-b65d-6c5117768a66/chemistry-501-introduction-to-bonding/#.WO62-9LytPY',
        'https://ca.pbslearningmedia.org/resource/75151b40-5d55-42d3-9975-a150cfd72c41/chemistry-701-introduction-to-the-mole-and-molar-mass/#.WzLKo9VKiUk',
        'https://www.tiki-toki.com/timeline/entry/64373/History-of-Educational-Technology/#vars!date=0321-02-05_10:36:14!',
        'https://writingcommons.org/chapters/the-writing-process/staying-focused/146-the-common-topoi-and-tagmemic-questions',
        'http://web.mnstate.edu/',
        'https://www.purplemath.com/',
        'https://www.toppr.com/',
        'https://www.khanacademy.org/',
        'http://www.montereyinstitute.org/',
        'https://study.com/',
        'http://www.mathplanet.com/',
        'http://jwilson.coe.uga.edu/'
      ],
      showLoadingMessage: true,
      showIframe: true
    }
  },

  mounted () {
    if (this.isStudentLogin) {
      return this.$router.push({ name: 'entityLearn', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid, topicUuid: this.topicUuid, subTopicUuid: this.subTopicUuid } })
    }
    this.loadCourse()
    this.setScormURL()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadEntityDetail',
      'startActivity',
      'stopActivity',
      'storeRating',
      'loadEntityCompetency',
      'loadToolProxies',
      'getScormPreviewURL'
    ]),

    setScormURL(){
        if (this.entity.fileType === 'scorm') {
          this.getScormPreviewURL(this.entity).then(res=>{
            this.scormPreviewUrl = res
          })
        }
    },

    loadCourse () {
      this.loadCourseDetail(this.uuid)
      var entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      this.loadEntityDetail(entityDetailInfo).then(res => {
        this.uri = this.handleSpecialDocuments(this.entity)
        if (res.whiteListed) {
          this.showLoadingMessage = !((res.fileType === 'video') || ((res.fileType === 'other') && (res.contentFileType.indexOf('video') !== -1)))
        } else {
          if (res.blackListed) {
            this.showIframe = false
          }
        }
        if (!res.whiteListed && !res.blackListed) {
          if (this.showLoadingMessage) {
            var whiteList = staticWhiteList()
            for (var i = 0; i < whiteList.length; i++) {
              if (res.uri === whiteList[i]) {
                this.showLoadingMessage = false
                break
              }
            }
          }
          if (this.showIframe) {
            for (var j = 0; j < this.blackList.length; j++) {
              let resourceUrl = this.blackList[j]
              if ((this.entity.uri === resourceUrl) || (this.entity.uri.indexOf(resourceUrl) !== -1)) {
                this.showIframe = false
                break
              }
            }
          }
        }
        if (this.showLoadingMessage && this.showIframe) {
          this.generateLtiLink()
        }
        i = 0
        j = 0
        var parentAncestorId = null
        for (i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === this.entity.ancestor) {
            if (this.linearTopics[j].title.indexOf(':') > -1) {
              this.parent = this.linearTopics[i].title.split(':')[0]
            } else {
              this.parent = this.linearTopics[i].title
            }
            parentAncestorId = this.linearTopics[i].ancestor
            break
          }
        }

        if (parentAncestorId != null) {
          for (j = 0; j < this.linearTopics.length; j++) {
            if (this.linearTopics[j].uuid === parentAncestorId) {
              if (this.linearTopics[j].title.indexOf(':') > -1) {
                this.ancestor = this.linearTopics[j].title.split(':')[0]
              } else {
                this.ancestor = this.linearTopics[j].title
              }
              break
            }
          }
        }
      })
      var entityDetailInfo2 = {
        'courseId': this.uuid,
        'entityId': this.entityUuid
      }
      this.loadEntityCompetency(entityDetailInfo2)
    },

    generateLtiLink () {
      this.isLtiLink = false
      this.loadToolProxies(this.uuid).then(res => {
        this.proxies = (res) ? res.content : []
        if (this.proxies.length > 0) {
          for (let i = 0; i < this.proxies.length; i++) {
            let proxy = this.proxies[i]
            let domain = proxy.tool.launchURL.split('/')[2]
            let parts = domain.split('.')
            let index = (parts.length > 2) ? 1 : 0
            let appProxy = parts[index].toLowerCase()
            if (this.entity.uri.toLowerCase().indexOf(appProxy) !== -1) {
              this.isLtiLink = true
              let origin = window.location.origin
              let token = localStorage.getItem('token')
              this.ltiLaunchUrl = origin + '/toolProxy/launch/' + this.entityUuid + '/' + proxy.uuid + '?token=' + token
              break
            }
          }
        }
      })
    },

    handleSpecialDocuments (content) {
      if (specialDocuments[content.fileType]) {
        var uri = content.uri
        var versionIdWithValue = ''
        if (uri.indexOf('?versionId=') !== -1) {
          versionIdWithValue = uri.substring(uri.indexOf('?versionId='), uri.length)
          uri = uri.substring(0, uri.indexOf('?versionId='))
        }
        if (this.isUriContainsSpecialCharacter(uri)) {
          var modifiedUri = uri.substring(0, uri.lastIndexOf('/'))
          modifiedUri = modifiedUri.concat('/').concat(encodeURIComponent(uri.substring(uri.lastIndexOf('/') + 1, uri.length)))
          let encodedUri = encodeURIComponent(modifiedUri)
          encodedUri += versionIdWithValue
          if (content.fileType === 'pdf' || content.fileType === 'doc' || content.fileType === 'docx' || content.fileType === 'ppt' || content.fileType === 'pptx') {
            content.iframeUrl = 'https://drive.google.com/viewerng/viewer?url=' + encodedUri + '&embedded=true'
          } else if (content.fileType === 'html' || content.fileType === 'other') {
            content.iframeUrl = encodedUri
          }
          return (content.fileType === 'pdf' && encodedUri.indexOf('s3-us-west-2.amazonaws.com') !== -1) ? decodeURIComponent(encodedUri) : ('https://drive.google.com/viewerng/viewer?url=' + encodedUri + '&embedded=true')
        }
        let encodedUri = encodeURIComponent(uri)
        encodedUri += versionIdWithValue
        if (content.fileType === 'pdf' || content.fileType === 'doc' || content.fileType === 'docx' || content.fileType === 'ppt' || content.fileType === 'pptx') {
          content.iframeUrl = 'https://drive.google.com/viewerng/viewer?url=' + encodedUri + '&embedded=true'
        } else if (content.fileType === 'html' || content.fileType === 'other') {
          content.iframeUrl = encodedUri
        }
        return (content.fileType === 'pdf' && encodedUri.indexOf('s3-us-west-2.amazonaws.com') !== -1) ? decodeURIComponent(encodedUri) : ('https://drive.google.com/viewerng/viewer?url=' + encodedUri + '&embedded=true')
      }
      content.iframeUrl = content.uri
      return content.uri
    },

    isUriContainsSpecialCharacter (uri) {
      return uri.indexOf('+') !== -1 || uri.indexOf('#') !== -1 || uri.indexOf('%') !== -1 || uri.indexOf('&') !== -1 || uri.indexOf('') !== -1
    },

    sendRating () {
      var ratingInfo = {
        'courseId': this.uuid,
        'learningContentId': this.entityUuid,
        'userId': localStorage.getItem('userid'),
        'institutionId': null,
        'rating': this.rating,
        'ratingLabel': null
      }
      this.storeRating(ratingInfo)
      $('#ok-btn').prop('disabled', false)
      $('#ok-btn').removeClass('disabled')
    },

    leaving () {
      var stopActivity = {
        'userId': localStorage.getItem('userid'),
        'entityUuid': this.entityUuid
      }
      this.stopActivity(stopActivity)
      if (this.entityCompetency && this.entityCompetency.status === 2) {
        return this.$router.push({ name: 'entityDetail', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid } })
      } else {
        return this.$router.push({ name: 'entityResult', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid } })
      }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'entity': state => state.course.entity,
      'entityCompetency': state => state.course.entityCompetency,
      'isTocOpen': state => state.course.isTocOpen,
      'linearTopics': state => state.course.linearTopics
    }),
    isStudentLogin: function () {
      return (localStorage.getItem('userrole') === 'Student')
    }
  },

  watch: {
    entityUuid (newId) {
      if (newId) {
        this.loadCourse()
      }
    }
  }
}
</script>

<style scoped>

.header {
	background: #f7e5a8;
	margin-bottom: 30px;
	float: left;
    width: 100%;
	padding-left: 20px;
	height:62px;
}
img {
	width:28px;
	height:26px;
}
.heading {
	float: left;
	font-size: 20px;
	margin-top: 17px;
	color: rgb(79, 79, 79);
	font-family: robotoSlab_Light;
	max-width: 85%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.btn_container {
	float: right;
	margin: 17px 18px 0 18px;
}
.container {
	width: 90%;
	max-width: 90%;
	margin-left: 5%;
	height: 98%;
}
.container iframe {
	width: 90% !important;
	margin-left: 5%;
	height: 95%;
}

.content{
  padding-top: 40px;
  margin-right: 30px;
  margin-left: 30px;
}

.course-nav{
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item{
  background:#e1e1e1;
  border: none;
}

.course-thumbnail{
  background:#f8f9fa;
  min-height: 500px;
}

.course-information{
  margin-top:20px;
}

.course-description {
	padding: 0px;
}

.course-description-card{
  background:#f8f9fa;
  border-color: #f8f9fa;
}

.topic-list-item{
}

.entity-nav{
  background: #f8f9fa;
}
.pull-left{
  float:left;
}

.learning{
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/app/course/components/EntityLearnInstructor.vue